<template>
  <div>
    <v-row>
      <v-col cols="3">
        <location-status
          label="Location status"
          v-model="locationStatus"
        ></location-status>
      </v-col>
      <v-col cols="3">
        <hub-site
          label="HUB site"
          v-model="hubSite"
        ></hub-site>
      </v-col>
      <v-col cols="3">
        <site-type
          label="Site type"
          v-model="siteType"
        >
        </site-type>
      </v-col>
      <v-col cols="3">
        <radio-equipment-type
          label="Radio equipment type"
          v-model="radioEquipmentType"
        >
        </radio-equipment-type>
      </v-col>
    </v-row>
  </div>
</template>

<script>
  import HubSite from '@/components/codelist/HUBSite'
  import RadioEquipmentType from '@/components/codelist/RadioEquipmentType'
  import SiteType from '@/components/codelist/SiteType'
  import LocationStatus from '@/components/codelist/LocationStatus'
  export default {
    name: 'CommonSearch',
    components: { LocationStatus, SiteType, RadioEquipmentType, HubSite },
    props: {
      value: {
        default: null,
      },
    },
    data: () => ({
      locationStatus: undefined,
      hubSite: undefined,
      siteType: undefined,
      radioEquipmentType: undefined,
    }),
    watch: {
      locationStatus: function (newValue, oldValue) {
        this.filterChanges()
      },
      hubSite: function (newValue, oldValue) {
        this.filterChanges()
      },
      siteType: function (newValue, oldValue) {
        this.filterChanges()
      },
      radioEquipmentType: function (newValue, oldValue) {
        this.filterChanges()
      },
    },
    methods: {
      filterChanges () {
        this.$emit('input', {
          'location-status': this.locationStatus,
          'hub-site': this.hubSite,
          'site-type': this.siteType,
          'radio-equipment-type': this.radioEquipmentType,
        })
      },
      clear () {
        this.locationStatus = undefined
        this.hubSite = undefined
        this.siteType = undefined
        this.radioEquipmentType = undefined
      },
    },
  }
</script>

<style scoped>

</style>
